import CalendarEvent from 'owa-calendar-types/lib/types/CalendarEvent';
import { getCalendarCharmIdByFolderId } from 'owa-calendar-events-store';

export function getCharm(item: CalendarEvent): number {
    let charmId = item && item.CharmId;
    return charmId || getCalendarCharmIdByFolderId(item.ParentFolderId.Id);
}
